import { render } from "./OffsetPagination.vue?vue&type=template&id=11770335&ts=true"
import script from "./OffsetPagination.vue?vue&type=script&lang=ts"
export * from "./OffsetPagination.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__